<template>
  <div class="fixedArea">
    <!-- <div class="area row-center">
      <img :src="$store.state.project.projectInfo.projectImg" alt="">
		  <h1>{{$store.state.project.projectInfo.buildingName}}</h1>
    </div> -->
    <div class="list">
      <div class="search">
        <input type="text" v-model="filterText" placeholder="请输入关键字" />
        <img src="@/assets/img/search.png" alt="" />
      </div>
      <!-- //配电 -->
      <div class="tree" id="index-tree" v-if="projectType=='1'"> 
        <el-scrollbar style="height:100%" >
          <el-tree
            :props="defaultProps1"
            default-expand-all
            check-on-click-node
            @node-check="nodeClick"
            @check="currentChange"
            node-key="loopId"
            ref="tree"
            :data="treeData"
            :filter-node-method="filterNode"
          >
            <span
              slot-scope="{ node, data }"
              class="power-data-item"
            >
              <span
                :class="[ 
                  'power-data-item-label ',
                  { checked: data.loopId === currentLoop.loopId },
                ]"
              >
                <span slot="reference" :title="data.name"> {{ data.name }}</span>
              </span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="tree" id="index-tree" v-else>
        <el-scrollbar style="height:100%" >
          <el-tree
            :props="defaultProps"
            default-expand-all
            check-on-click-node
            @node-check="nodeClick"
            @check="currentChange"
            node-key="id"
            ref="tree"
            :data="treeData"
            :filter-node-method="filterNode"
          >
            <span
              slot-scope="{ node, data }"
              class="power-data-item"
            >
              <span
                :class="[ 
                  'power-data-item-label ',
                  { checked: data.id === currentLoop.id },
                ]"
              >
                <span slot="reference" :title="data.name"> {{ data.name }}</span>
              </span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import {
  treeBuilding,GET_AREAS,consumerAnalysisItemLoopTree
} from "../../../api/power";
import {
  perDay,
  perMonth,
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  dateToString,
  dayStart,
  dayEnd,
  addDay,
  getAppointedDate,
  getDiffDate,
  weekStart,
  weekEnd,
} from "../../../util/DateUtil";
export default {
  name: "",
  components: {},
  props:{
    currentLoop:Object,
  },
  data() {
    return {
      selectedNodes: [],
      showAreaNumber: 0,
      reFresh: true,
      checkedLoops: [],
      // currentLoop: null,
      filterText: "",
      listShow: false,
      areaFilterText: "",
      defaultchecked: null,
      treeData: [],
      defaultchecked: null,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      defaultProps1: {
        children: 'deviceLoops',
        label: 'name'
      }
    };
  },

  computed: {
    tag() {
      return this.$route.params.tag;
    },
    routeName() {
      return this.$route.params.name;
    },
    projectType() {  //1-配电,2-楼栋
        return this.$store.getters.selProjectInfo.projectType;
    },
  },
  mounted() {
    this.GetreeBuilding();
  },
  methods: {
      //楼栋
    GetreeBuilding(){
      if(this.projectType==1){
        consumerAnalysisItemLoopTree().then((res) => {
          res.data.data.forEach(element => {
            element.deviceLoops.forEach(elm=>{
              elm.name = elm.loopName
            })
          });
          this.treeData = res.data.data
        })
        // GET_AREAS().then((res) => {
        //   if(res.data.status){
        //     this.treeData = res.data.data.areas.map(e=>{e.name=e.areaName;e.id=e.areaId;return e})
        //   }
        //   // this.currentLoop = this.treeData[0]
        // });
      }else{
        treeBuilding().then((res) => {
          if(res.data.status){
            this.treeData = res.data.data.tree
          }
          // this.currentLoop = this.treeData[0]
        });
      }
      
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    nodeClick(data) {
        // this.currentLoop = data;
    },
    currentChange(data, node, n) {
      this.selectedNodes = node.checkedNodes;
      this.checkedLoops = this.selectedNodes.filter((l) => {
        return l ? l.name.indexOf(this.filterText) !== -1 : false;
      });
      // this.currentLoop= data
      this.$emit("getcurrentLoop",data)
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-tree .el-tree-node,/deep/.el-tree .el-tree-node__content{
   min-height: 35px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    width: 100%;
    display: block;
}
.power-data-item-label.checked {
    font-weight: bold;
    color: #0d94ff;
  }
.area {
		justify-content: flex-start;
		padding: 16rem 24rem;
		border-bottom: 1px solid #E5E5E5;
		width: 100%;

    h1 {
      font-size: 24rem;
      font-weight: bold;
      color: #333333;
          white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
  > img {
    .w(64);
    .h(64);
    margin-right: 15rem;
  }

  > div {
    .h(64);
    justify-content: space-between !important;

    p {
      width: 100%;
      font-size: 16rem;
      color: #999999;
       white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    }
  }

  .name {
    justify-content: space-between;
    width: 100%;

    h1 {
      font-size: 24rem;
      font-weight: bold;
      color: #333333;
          white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    }
  }
}
.fixedArea {
  position: absolute;
  left: 0;
  top: 100%;
  width:100%;
  height: 270rem;
  background-color: #fff;
  box-shadow: 0 4rem 40px 0 rgba(0, 43, 102, 0.28);
  padding: 20rem;
  z-index: 999;
}
.clearsel {
  height: 45rem;
  line-height: 45rem;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  width: 100%;
  text-align: center;
  font-size: 18rem;
  cursor: pointer;
}
.area-list {
  position: absolute;
  left: 0;
  top: 0;
  .w(504);
  .h(520);
  background-color: #fff;
  box-shadow: 0 4rem 40px 0 rgba(0, 43, 102, 0.28);
  padding: 24rem 16rem;
  z-index: 999;

  .areas {
    margin-top: 24rem;
    // min-height: 200rem;
    .h(400);
    overflow: auto;
    .row {
      margin-bottom: 24rem;

      p {
        font-size: 16rem;
        color: #333333;
        font-weight: 400;
        .w(400);
      }

      img {
        .w(48);
        .h(48);
        margin-right: 13rem;
        margin-left: 8rem;
      }
    }
  }

  .search {
    .h(48);
    width: 100%;
    overflow: hidden;
    border-radius: 24rem;
    border: 1px solid rgba(0, 0, 0, 0.15);
    position: relative;

    input {
      width: 100%;
      height: 100%;
      padding: 0 20rem;
      font-size: 16rem;
      color: #000000;
      font-weight: 400;
      line-height: 48rem;
    }

    img {
      position: absolute;
      right: 16rem;
      top: 15rem;
      z-index: 99;
    }
  }
}

.fixedArea {
  .list {
    overflow: hidden;
    width: 100%;
    height: 100%;
    .search {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
    }

    input {
      border: none;
      outline: none;
      font-size: 18rem;
      color: #666666;
      width:100%
    }

    .tree {
      margin-top: 15rem;
      height:calc(100% - 30px);
      overflow: auto;

      .el-tree {
        padding-right: 0;
      }
    }
  }
}

.el-tree {
  padding-right: 33rem;
}
</style>
